<template>
  <div class="staff-item slider-selection-item"
    @click="gotoPage">
    <div class="slider-selection-card change-page">
      <div class="slider-selection-card-img img-lazyload-container">
        <img
          class="img-lazyload"
          data-lazyload="true"
          :src="img | imgFilter"
          alt="Landmannalaugar"
          title="Randonn"
        >
      </div>
      <div class="slider-selection-card-content">
        <h4 class="slider-selection-card-title ft-16">{{ title }}</h4>
        <div
          class="slider-selection-card-price"
        >{{ info | substrFilter }}</div>
        <div class="date ft-12">{{ date | dateFilter }}</div>
        <div class="line"></div>
        <div class="readmore ft-12">Read More</div>
      </div>
      <!-- <div class="slider-selection-card-button">
        <span>深入了解</span>
      </div> -->
      <div class="anim-line">
        <div class="anim"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: String,
    img: String,
    title: String,
    info: String,
    date: String
  },

  methods: {
    gotoPage () {
      this.$router.push(`/sangle1/${this.id}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.slider-selection-item {
  cursor: pointer;
  // display: inline-block;
  width: 320px;
  // padding: 0 38px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  position: relative;
  // position: absolute;
  // left: 0;
  // z-index: 1020;
}

.slider-selection-card {
  text-decoration: none;
  min-height: 405px;
  font-size: 14px;
  color: #242a3a;
  width: 100%;
  display: block;
  position: relative;
  background-color: #fff;
  overflow: hidden;
  // background-color: #242a3a;
  -webkit-box-shadow: -1px 4px 74px -16px rgba(0, 0, 0, 0.15);
  box-shadow: -1px 4px 74px -16px rgba(0, 0, 0, 0.15);
}

.slider-selection-card-img {
  width: 100%;
  height: 179px;
  overflow: hidden;
  position: relative;
  overflow: hidden;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

.slider-selection-card-img img {
  width: 100%;
  opacity: 1;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-transform: scale(1);
  transform: scale(1);
  -webkit-transition: opacity 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94),
    -webkit-transform 0.8s cubic-bezier(0.165, 0.84, 0.44, 1);
  transition: opacity 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94),
    -webkit-transform 0.8s cubic-bezier(0.165, 0.84, 0.44, 1);
  transition: opacity 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94),
    transform 0.8s cubic-bezier(0.165, 0.84, 0.44, 1);
  transition: opacity 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94),
    transform 0.8s cubic-bezier(0.165, 0.84, 0.44, 1),
    -webkit-transform 0.8s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.slider-selection-card-content {
  height: 280px;
  background-color: #fff;
  padding: 24px 30px 24px 30px;
  white-space: auto;
}

.slider-selection-card-title {
  // font-size: 24px;
  line-height: 26px;
}

.slider-selection-card-desc {
  margin-bottom: 10px;
  color: #80c7de;
}

.slider-selection-card-infos {
  line-height: 20px;
}

.slider-selection-card-infos-item {
  display: inline-block;
  width: 110px;
}

.slider-selection-card-infos .icon {
  width: 14px;
  height: 14px;
  fill: #242a3a;
  vertical-align: middle;
  display: inline-block;
  margin-right: 10px;
}

.slider-selection-card-price {
  border-top: 1px solid #eaeaea;
  padding-top: 18px;
  margin-top: 18px;
}

.slider-selection-card-price strong {
  color: #96daf0;
  display: block;
  font-size: 36px;
  margin-top: 12px;
}

.slider-selection-card-nbtravels {
  border-top: 1px solid #eaeaea;
  padding-top: 8px;
  margin-top: 18px;
}

.slider-selection-card-nbtravels strong {
  color: #96daf0;
  display: block;
  font-size: 20px;
  margin-top: 12px;
}

.slider-selection-card-button {
  display: block;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 30px;
  background-color: #242a3a;
  color: #fff;
  z-index: 1050;
  overflow: hidden;
  -webkit-transform: translateY(20px);
  transform: translateY(20px);
  -webkit-transition: background 0.5s cubic-bezier(0.165, 0.84, 0.44, 1) 0s,
    -webkit-transform 0.5s cubic-bezier(0.165, 0.84, 0.44, 1);
  transition: background 0.5s cubic-bezier(0.165, 0.84, 0.44, 1) 0s,
    -webkit-transform 0.5s cubic-bezier(0.165, 0.84, 0.44, 1);
  transition: transform 0.5s cubic-bezier(0.165, 0.84, 0.44, 1),
    background 0.5s cubic-bezier(0.165, 0.84, 0.44, 1) 0s;
  transition: transform 0.5s cubic-bezier(0.165, 0.84, 0.44, 1),
    background 0.5s cubic-bezier(0.165, 0.84, 0.44, 1) 0s,
    -webkit-transform 0.5s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.slider-selection-card-button span {
  display: block;
  position: absolute;
  text-align: center;
  font-size: 12px;
  left: 0;
  width: 100%;
  -webkit-transform: translateY(80px);
  transform: translateY(80px);
  -webkit-transition: -webkit-transform 0.5s cubic-bezier(0.77, 0, 0.175, 1) 0s;
  transition: -webkit-transform 0.5s cubic-bezier(0.77, 0, 0.175, 1) 0s;
  transition: transform 0.5s cubic-bezier(0.77, 0, 0.175, 1) 0s;
  transition: transform 0.5s cubic-bezier(0.77, 0, 0.175, 1) 0s,
    -webkit-transform 0.5s cubic-bezier(0.77, 0, 0.175, 1) 0s;
}

.slider-selection-card:hover .slider-selection-card-button {
  background-color: #96daf0;
  -webkit-transform: translateY(0);
  transform: translateY(0);
  -webkit-transition: background 0.7s cubic-bezier(0.165, 0.84, 0.44, 1),
    -webkit-transform 0.7s cubic-bezier(0.165, 0.84, 0.44, 1);
  transition: background 0.7s cubic-bezier(0.165, 0.84, 0.44, 1),
    -webkit-transform 0.7s cubic-bezier(0.165, 0.84, 0.44, 1);
  transition: transform 0.7s cubic-bezier(0.165, 0.84, 0.44, 1),
    background 0.7s cubic-bezier(0.165, 0.84, 0.44, 1);
  transition: transform 0.7s cubic-bezier(0.165, 0.84, 0.44, 1),
    background 0.7s cubic-bezier(0.165, 0.84, 0.44, 1),
    -webkit-transform 0.7s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.slider-selection-card:hover .slider-selection-card-button span {
  -webkit-transform: translateY(6px);
  transform: translateY(6px);
  -webkit-transition: -webkit-transform 0.7s cubic-bezier(0.77, 0, 0.175, 1) 0s;
  transition: -webkit-transform 0.7s cubic-bezier(0.77, 0, 0.175, 1) 0s;
  transition: transform 0.7s cubic-bezier(0.77, 0, 0.175, 1) 0s;
  transition: transform 0.7s cubic-bezier(0.77, 0, 0.175, 1) 0s,
    -webkit-transform 0.7s cubic-bezier(0.77, 0, 0.175, 1) 0s;
}

.slider-selection-card:hover .slider-selection-card-img img {
  -webkit-transform: scale(1.15);
  transform: scale(1.15);
}

.date {
  line-height: 32px;
}

.line {
  height: 1px;
  width: 10px;
  background-color: #000;
  margin: 16px;
}
.readmore {
  font-style: italic;
}

.anim-line {
  .anim {
    width: 0;
    height: 2px;
    background-color: #03192f;
    transition: width 0.7s cubic-bezier(0.165, 0.84, 0.44, 1);
  }
}

.slider-selection-card:hover .anim-line {
  .anim {
    width: 100%;
  }
}
</style>
